import { render, staticRenderFns } from "./updateBalance.vue?vue&type=template&id=d05b1f0c&scoped=true&"
import script from "./updateBalance.vue?vue&type=script&lang=js&"
export * from "./updateBalance.vue?vue&type=script&lang=js&"
import style0 from "./updateBalance.vue?vue&type=style&index=0&id=d05b1f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05b1f0c",
  null
  
)

export default component.exports